import { render, staticRenderFns } from "./LeadCard.vue?vue&type=template&id=5b0daaa4&scoped=true&"
import script from "./LeadCard.vue?vue&type=script&lang=js&"
export * from "./LeadCard.vue?vue&type=script&lang=js&"
import style0 from "./LeadCard.vue?vue&type=style&index=0&id=5b0daaa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0daaa4",
  null
  
)

export default component.exports